import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import type { Period, ReceiptMode } from './useSalesComparison';

interface Props {
    period: Period;
    current: boolean;
    receiptMode: ReceiptMode;
    onReceiptMode: (mode: ReceiptMode) => void;
}

export function SalesComparisonControls({ period, current, receiptMode, onReceiptMode }: Props) {
    const choiceKey = `${period}-${current ? 'cur' : 'prev'}`;

    return (
        <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2, flexWrap: 'wrap' }}>
            <ToggleButtonGroup size="small" exclusive value={choiceKey}>
                <ToggleButton value="week-cur" href="#/sales/reports/week/current" component="a">Innevarande vecka</ToggleButton>
                <ToggleButton value="week-prev" href="#/sales/reports/week/previous" component="a">Föregående vecka</ToggleButton>
                <ToggleButton value="month-cur" href="#/sales/reports/month/current" component="a">Innevarande månad</ToggleButton>
                <ToggleButton value="month-prev" href="#/sales/reports/month/previous" component="a">Föregående månad</ToggleButton>
            </ToggleButtonGroup>
            <ToggleButtonGroup size="small" exclusive value={receiptMode} onChange={(_, value) => value && onReceiptMode(value)}>
                <ToggleButton value="all">Alla köp</ToggleButton>
                <ToggleButton value="pos">Positiva köp</ToggleButton>
            </ToggleButtonGroup>
        </Stack>
    );
}
